import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatIconRegistry, MatTableDataSource, PageEvent, Sort } from '@angular/material';
import { LockedUsersData } from '../locked-users.model';
import { OapErrorMessages, OapStandarErrorStateMatcher, errorMessages } from '../../custom-validators/custom-validators.module';
import { AlertService } from 'src/app/services/alert.service';
import { MessageService } from 'src/app/services/message.service';
import { LockedUsersService } from '../locked-users.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthToken } from 'src/app/models/authToken';
import { DatePipe } from '@angular/common';
import { first } from 'rxjs/operators';
import { ConfirmDialogService } from '../../gestionnaire/shared/confirm-dialog.service';

export interface SearchLockedUser {
  compteKey: null,
  login: null
}

@Component({
  selector: 'oap-locked-users',
  templateUrl: './locked-users.component.html',
  styleUrls: ['./locked-users.component.scss']
})
export class LockedUsersComponent implements OnInit {
  authToken: AuthToken;
  searchForm: FormGroup;

  displayedColumns: string[] = ['compteKey', 'login', 'actif', 'tentative', 'dateBlocage', 'actions'];
  dataSource: MatTableDataSource<LockedUsersData>;
  loading = false;
  results: LockedUsersData[] = [];

  tooltip_unlock_user = 'Débloquer le compte du patient';
  tooltip_lock_user = 'Bloquer temporairement le compte du patient';
  tooltip_delete_user = 'Supprimer définitivement le compte du patient';

  // information pour le paginator
  totalItems = 100;
  pageSize = 8;
  pageRequested = 1; // page for back base index 1
  pageIndex = 0; // page index paginator base index 0 
  totalPages = 1;
  pageSizeOptions: number[] = [2, 4, 8, 16];
  sortColumnName = 'CompteKey'; // numéro de la colonne à trié
  sortOrder = 'ASC'; // asc ou desc
  viewDocumentAllow = true; // autorise la vue des documents
  btnDeleteAllow = false; // autorise la suppression de document

  // MatPaginator Output
  pageEvent: PageEvent;

  matcher = new OapStandarErrorStateMatcher();
  errors = errorMessages;
  validation_messages = OapErrorMessages;

  viewButtonExport = false; // autorise la vue du boutton export excel
  viewPaginator = true;
  submitted = false;

  currentLockedUser: LockedUsersData;

  constructor(public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private lockedUsersService: LockedUsersService,
    private messageService: MessageService,
    private alertService: AlertService,
    private confirmDialogService: ConfirmDialogService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,) {

    iconRegistry.addSvgIcon('unlock', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/lock_open_black_24dp.svg'));
    iconRegistry.addSvgIcon('lock', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/lock_outline_black_24dp.svg'));

    iconRegistry.addSvgIcon('delete', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-delete-24px.svg'));

    this.authToken = JSON.parse(localStorage.getItem('currentUser'));
    console.log(' id :' + this.authToken.id);
  }

  ngOnInit() {
    this.messageService.sendMessage('page-users-locked');
    this.alertService.clear();

    const date = new Date();
    date.setDate(date.getDate() - 10);
    const datePipe = new DatePipe('en-US');
    const nowMinus10 = datePipe.transform(date, 'yyyy-MM-dd');

    this.searchForm = this.formBuilder.group({
      login: ['', Validators.maxLength(255)],
    });

    this.onFormSubmit(this.searchForm);
  
  }

  sortData(sort: Sort) {
    this.alertService.clear();
    this.sortOrder = sort.direction;

    switch (sort.active) {
      case 'compteKey':
        this.sortColumnName = 'CompteKey';
        break;
      case 'login':
        this.sortColumnName = 'Identifiant';
        break;
      case 'dateBlocage':
        this.sortColumnName = 'DateBlocage';
        break;
      default:
        this.sortColumnName = 'CompteKey';
        break;
    }

    // console.log('launch sort');
    this.onFormSubmit(this.searchForm);

  }

  onFormSubmit(form: FormGroup) {
    this.alertService.clear();

    this.submitted = true;
    this.loading = true;
    this.viewButtonExport = false;

    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    const searchElement = this.getSearchElement();

    this.doServiceSearch(searchElement);

  }

  private doServiceSearch(searchLockedUser: SearchLockedUser) {
    console.log('TimezoneOffset :' + new Date().getTimezoneOffset());

    this.lockedUsersService.findLockedUsers(searchLockedUser, this.pageRequested, this.pageSize, this.sortColumnName, this.sortOrder)
      .pipe(first())
      .subscribe(
        data => {

          this.pageRequested = data.pageRequested;
          this.pageIndex = data.pageRequested - 1;
          this.pageSize = data.numberOfItemsByPage;
          this.totalPages = data.numberOfPages;
          this.totalItems = data.numberOfItems;

          this.results = [];
          data.items.forEach((element: any) => {
            this.results.push(createSearchResultData(element));
          });
          
          this.dataSource = new MatTableDataSource(this.results);

          if (this.results.length > 0) {
            this.viewButtonExport = true;
            this.viewPaginator = true;
          } else {
            this.viewButtonExport = false;
            this.viewPaginator = false;
          }

        },
        error => {
          console.error(error);
          this.alertService.error(error, true);
          this.loading = false;
          this.viewButtonExport = false;
          this.viewPaginator = false;
        },
        () => { this.loading = false; });
  }

  
  private getSearchElement(): SearchLockedUser {
    const datePipe = new DatePipe('en');

    return {
      compteKey: null,
      login: this.searchForm.controls.login.value === "" ? null : this.searchForm.controls.login.value ,
    };

  }

  onPageEvent(event: PageEvent) {
    this.alertService.clear();
   
    this.pageIndex = event.pageIndex;
    this.pageRequested = this.pageIndex + 1;
    this.pageSize = event.pageSize;

    const searchElement = this.getSearchElement();

    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.doServiceSearch(searchElement);
  }

  clearSearchForm() {
    this.searchForm.patchValue(
      {
        login: null
      });

    this.onFormSubmit(this.searchForm);
    this.viewButtonExport = false;

  }

  onUnlockUser (lockedUser: LockedUsersData) {
    console.log('Unlock user : ' + lockedUser.compteKey);

    this.lockedUsersService.unlockUser(lockedUser.compteKey)
      .pipe(first())
      .subscribe(
        data => {
          const searchElement = this.getSearchElement();

          this.submitted = true;
          this.loading = true;
      
          // stop here if form is invalid
          if (this.searchForm.invalid) {
            return;
          }
      
          this.doServiceSearch(searchElement);

          this.alertService.success('Utilisateur débloqué avec succès', false);
        },
        error => {
          console.error(error);
          this.alertService.error(error, true);
        });
  }

  onLockUser (lockedUser: LockedUsersData) {
    console.log('lock user : ' + lockedUser.compteKey);

    this.lockedUsersService.lockUser(lockedUser.compteKey)
      .pipe(first())
      .subscribe(
        data => {
          const searchElement = this.getSearchElement();

          this.submitted = true;
          this.loading = true;
      
          // stop here if form is invalid
          if (this.searchForm.invalid) {
            return;
          }
      
          this.doServiceSearch(searchElement);

          this.alertService.success('Utilisateur bloqué temporairement avec succès', false);
        },
        error => {
          console.error(error);
          this.alertService.error(error, true);
        });
  }

  onEnableUser(lockedUser: LockedUsersData) {
    console.log(' onEnableUser :' + lockedUser.actif);
    
    lockedUser.actif = !lockedUser.actif;

    this.lockedUsersService.enable(lockedUser.compteKey, lockedUser.actif)
      .pipe(first())
      .subscribe(
        data => {
          this.alertService.success('Mise à jour réussie', false);
        },
        error => {
          console.error(error)
          this.alertService.error(error, true);
        });

  }

  onDeleteUser(lockedUser: LockedUsersData) {
    console.log('onDeleteUser :' + lockedUser.compteKey);

    this.confirmDialogService.openConfirmDialog('Le compte patient va être supprimer définitivement')
    .afterClosed().subscribe(res => {
      if (res) {
        console.log('do delete');
        this.lockedUsersService.deleteUser(lockedUser.compteKey)
          .pipe(first())
          .subscribe(
            data => {
              this.alertService.success('Compte supprimer avec succès', false);
            },
            error => {
              console.error(error)
            this.alertService.error(error, true);
            });
       }
    });
  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

/** Builds and returns a new SearchResultData. */
function createSearchResultData(data: any): LockedUsersData {
  return {
    compteKey: data.compteKey,
    identifiant: data.identifiant,
    actif: data.actif,
    tentative: data.tentative,
    dateBlocageParis: data.dateBlocageParis
  };
}
